/* Eye in the Sky :: section interactions.
   Re-runs on shopify:section:load so everything stays live in the theme editor. */
(function () {
  if (window.__eitsBooted) return
  window.__eitsBooted = true

  var $ = function (s, r) { return (r || document).querySelector(s) }
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)) }

  /* ---------------------------------------------------------- Nav */
  function initNav(root) {
    var header = $('#eits-header', root)
    if (!header) return
    var brand = header.querySelectorAll('a span span')
    var navLinks = $$('nav.hidden a', header)
    var menuBtn = $('#eits-menu-btn', header)
    var menu = $('#eits-mobile-menu', header)

    if (menuBtn && menu) {
      menuBtn.addEventListener('click', function () {
        var open = menu.classList.toggle('hidden') === false
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false')
      })
      $$('.eits-mlink', menu).forEach(function (a) {
        a.addEventListener('click', function () { menu.classList.add('hidden') })
      })
    }

    if (header.getAttribute('data-nav-position') !== 'overlay') return

    function onScroll() {
      var s = window.scrollY > 24
      header.classList.toggle('border-border', s)
      header.classList.toggle('border-transparent', !s)
      header.style.background = s
        ? 'color-mix(in srgb, var(--background) 88%, transparent)'
        : 'transparent'
      header.style.backdropFilter = s ? 'blur(10px)' : 'none'
      if (brand[0]) brand[0].style.color = s ? 'var(--foreground)' : '#fff'
      if (brand[1]) brand[1].style.color = s ? 'var(--primary)' : '#9cbaf0'
      navLinks.forEach(function (a) {
        a.style.color = s ? 'var(--muted-foreground)' : 'rgba(255,255,255,.8)'
      })
      if (menuBtn) {
        menuBtn.style.color = s ? 'var(--foreground)' : '#fff'
        menuBtn.style.borderColor = s ? 'var(--border)' : 'rgba(255,255,255,.3)'
      }
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
  }

  /* ---------------------------------------------------------- Gallery */
  function initGallery(root) {
    var section = $('#gallery', root)
    if (!section) return
    var tiles = $$('.eits-tile', section)
    var filters = $$('.eits-filter', section)
    var lb = $('#eits-lightbox', section)
    var visible = tiles.slice()
    var i = 0

    function paintFilters(active) {
      filters.forEach(function (b) {
        var on = b === active
        b.style.borderColor = on ? 'var(--primary)' : 'var(--border)'
        b.style.background = on ? 'var(--primary)' : 'var(--card)'
        b.style.color = on ? 'var(--primary-foreground)' : 'var(--muted-foreground)'
      })
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-filter')
        paintFilters(btn)
        visible = []
        tiles.forEach(function (t) {
          var show = cat === 'All' || t.getAttribute('data-cat') === cat
          t.style.display = show ? '' : 'none'
          if (show) visible.push(t)
        })
      })
    })

    function render() {
      var t = visible[i]
      if (!t || !lb) return
      var img = t.querySelector('img')
      $('#eits-lb-img', lb).src = img ? img.src : ''
      $('#eits-lb-img', lb).alt = t.getAttribute('data-title') || ''
      $('#eits-lb-cat', lb).textContent = t.getAttribute('data-cat') || ''
      $('#eits-lb-title', lb).textContent = t.getAttribute('data-title') || ''
    }
    function close() { if (lb) lb.classList.add('hidden') }
    function step(n) { i = (i + n + visible.length) % visible.length; render() }

    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        i = visible.indexOf(t); render(); if (lb) lb.classList.remove('hidden')
      })
    })

    if (lb) {
      lb.addEventListener('click', close)
      $('#eits-lb-fig', lb).addEventListener('click', function (e) { e.stopPropagation() })
      $('#eits-lb-close', lb).addEventListener('click', function (e) { e.stopPropagation(); close() })
      $('#eits-lb-prev', lb).addEventListener('click', function (e) { e.stopPropagation(); step(-1) })
      $('#eits-lb-next', lb).addEventListener('click', function (e) { e.stopPropagation(); step(1) })
      document.addEventListener('keydown', function (e) {
        if (lb.classList.contains('hidden')) return
        if (e.key === 'Escape') close()
        if (e.key === 'ArrowLeft') step(-1)
        if (e.key === 'ArrowRight') step(1)
      })
    }
  }

  /* ---------------------------------------------------------- Testimonials */
  function initTestimonials(root) {
    var data = $('#eits-testimonials-data', root)
    var quote = $('#eits-t-quote', root)
    if (!data || !quote) return
    var items = []
    try { items = JSON.parse(data.textContent) } catch (e) { return }
    if (!items.length) return
    var dots = $$('.eits-dot', root)
    var i = 0

    function render() {
      var t = items[i]
      quote.textContent = '\u201C' + t.quote + '\u201D'
      $('#eits-t-name', root).textContent = t.name
      $('#eits-t-role', root).textContent = t.role
      dots.forEach(function (d, n) {
        d.style.width = n === i ? '32px' : '10px'
        d.style.background = n === i ? 'var(--primary)' : 'var(--border)'
      })
    }
    var prev = $('#eits-t-prev', root)
    var next = $('#eits-t-next', root)
    if (prev) prev.addEventListener('click', function () { i = (i - 1 + items.length) % items.length; render() })
    if (next) next.addEventListener('click', function () { i = (i + 1) % items.length; render() })
    dots.forEach(function (d) {
      d.addEventListener('click', function () { i = +d.getAttribute('data-dot'); render() })
    })
    render()
  }

  /* ---------------------------------------------------------- Hero canvas */
  function initCanvas(root) {
    var canvas = $('#eits-canvas', root)
    if (!canvas || !canvas.getContext) return
    var ctx = canvas.getContext('2d')
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    var w = 0, h = 0, raf = 0

    function resize() {
      var r = canvas.getBoundingClientRect()
      var dpr = Math.min(window.devicePixelRatio || 1, 2)
      w = r.width; h = r.height
      canvas.width = w * dpr; canvas.height = h * dpr
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
    }
    resize()
    window.addEventListener('resize', resize)

    var particles = []
    for (var n = 0; n < 16; n++) {
      particles.push({
        x: Math.random() * w, y: Math.random() * h,
        vx: (Math.random() - 0.5) * 0.25, vy: (Math.random() - 0.5) * 0.25,
        r: Math.random() * 1.4 + 0.3, a: Math.random() * 0.35 + 0.08
      })
    }
    var bolts = []
    function makeBolt() {
      var sx = Math.random() * w
      var sy = Math.random() < 0.5 ? 0 : h * (Math.random() * 0.4)
      var ex = sx + (Math.random() - 0.5) * w * 0.6
      var ey = sy + h * (0.4 + Math.random() * 0.5)
      var pts = []
      for (var k = 0; k <= 14; k++) {
        var t = k / 14
        var j = (k === 0 || k === 14) ? 0 : (Math.random() - 0.5) * 60
        pts.push({ x: sx + (ex - sx) * t + j, y: sy + (ey - sy) * t + (Math.random() - 0.5) * 20 })
      }
      var max = 14 + Math.random() * 10
      bolts.push({ points: pts, life: max, max: max })
    }
    function strokeBolt(b, color, width, blur) {
      ctx.beginPath()
      ctx.moveTo(b.points[0].x, b.points[0].y)
      for (var k = 1; k < b.points.length; k++) ctx.lineTo(b.points[k].x, b.points[k].y)
      ctx.strokeStyle = color
      ctx.lineWidth = width
      ctx.shadowColor = 'rgba(90, 130, 205, 0.8)'
      ctx.shadowBlur = blur
      ctx.stroke()
    }
    function draw() {
      ctx.clearRect(0, 0, w, h)
      particles.forEach(function (p) {
        p.x += p.vx; p.y += p.vy
        if (p.x < 0) p.x = w
        if (p.x > w) p.x = 0
        if (p.y < 0) p.y = h
        if (p.y > h) p.y = 0
        ctx.beginPath()
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2)
        ctx.fillStyle = 'rgba(156, 186, 240, ' + p.a + ')'
        ctx.fill()
      })
      if (!reduced && Math.random() < 0.01 && bolts.length < 2) makeBolt()
      bolts = bolts.filter(function (b) { return b.life > 0 })
      bolts.forEach(function (b) {
        var a = b.life / b.max
        strokeBolt(b, 'rgba(90, 130, 205, ' + a * 0.3 + ')', 5, 14)
        strokeBolt(b, 'rgba(210, 225, 255, ' + a + ')', 1.2, 6)
        ctx.shadowBlur = 0
        b.life -= 1
      })
      raf = requestAnimationFrame(draw)
    }
    raf = requestAnimationFrame(draw)
  }

  /* ---------------------------------------------------------- Anchors */
  function initAnchors(root) {
    $$('a[href^="#"]', root).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href')
        if (id.length < 2) return
        var el = document.querySelector(id)
        if (!el) return
        e.preventDefault()
        window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 64, behavior: 'smooth' })
      })
    })
  }

  function initAll(root) {
    root = root || document
    initNav(root)
    initGallery(root)
    initTestimonials(root)
    initCanvas(root)
    initAnchors(root)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll() })
  } else {
    initAll()
  }

  /* Theme editor: re-init a section when it is reloaded or a block changes */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target) })
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target.closest('[id^="shopify-section-"]') || document) })
})()